import { Dashboard, ShoppingBag } from '@mui/icons-material'
import React, { useState } from 'react'
import ShopTwoIcon from '@mui/icons-material/ShopTwo';
import CategoryIcon from '@mui/icons-material/Category';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import EventIcon from '@mui/icons-material/Event';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import { Divider, Drawer, IconButton, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../component/State/Authentication/Action';
import { Menu as MenuIcon } from '@mui/icons-material'; 


const menu=[
    {title:"Dashboard", icon:<Dashboard/>, path:"/"},
    {title:"Orders", icon:<ShoppingBag/>, path:"/orders"},
    {title:"Menu", icon:<ShopTwoIcon/>, path:"/menu"},
    {title:"Food Category", icon:<CategoryIcon/>, path:"/category"},
    {title:"Ingredients", icon:<FastfoodIcon/>, path:"/ingredients"},
    {title:"Events", icon:<EventIcon/>, path:"/event"},
    {title:"Details", icon:<AdminPanelSettingsIcon/>, path:"/details"},
    {title:"Logout", icon:<LogoutIcon/>, path:"/"},         
]

const AdminSideBar = ({handleClose}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const isSmallScreen=useMediaQuery("(max-width:1080px)")
    const navigate=useNavigate();
    const dispatch= useDispatch();

    const handleNavigate = (item) => {
      if (item.title === "Logout") {
          dispatch(logout());
          // handleClose();
          navigate("/"); // Logout path
      } else {
        navigate(`/admin/restaurants${item.path}`); // Adjust path if necessary
      }
      setIsDrawerOpen(false);
  };
  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };


  return (
    <div>
     {isSmallScreen && (
  <IconButton
    onClick={() => toggleDrawer(true)}
    sx={{
      position: 'front',
      top: 10, // Distance from the top of the screen
      left: 10, // Distance from the left of the screen
      zIndex: 1200, // Ensures the button stays on top of other elements
      fontSize: 30, // Adjust icon size as needed
    }}
  >
    <MenuIcon sx={{ fontSize: 'inherit' }} />
  </IconButton>
)}


      <Drawer
        variant={isSmallScreen ? "temporary" : "permanent"}
        open={isSmallScreen ? isDrawerOpen : true}
        onClose={() => toggleDrawer(false)}
        anchor="left"
        sx={{ zIndex: 1 }}
      >
        <div className="w-[70vw] lg:w-[20vw] h-screen flex flex-col justify-center text-xl space-y-[1.65rem]">
          {menu.map((item, i) => (
            <React.Fragment key={item.title}>
              <div onClick={() => handleNavigate(item)} className="px-5 flex items-center gap-5 cursor-pointer">
                {item.icon}
                <span>{item.title}</span>
              </div>
              {i !== menu.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </div>
      </Drawer>
    </div>
  );
};

export default AdminSideBar
